export const actions = {
  GET_OFFICE_BRANCHES_REQUEST: "GET_OFFICE_BRANCHES_REQUEST",
  GET_OFFICE_BRANCHES_SUCCESS: "GET_OFFICE_BRANCHES_SUCCESS",
  GET_OFFICE_BRANCHES_FAILURE: "GET_OFFICE_BRANCHES_FAILURE",
};
